import React from 'react'

const ProfileSetUp = () => {
  return (
    <div>ProfileSetUp</div>
  )
}

export default ProfileSetUp